module.exports = __webpack_public_path__ + "static/img/megaphone2.6292e1ce.png";